import { Capacitor, registerPlugin } from '@capacitor/core';

const ThemeIcon = registerPlugin('ThemeIcon');

export const applyThemeIcon = async (theme) => {
  const isIOSNative = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  if (!isIOSNative) return;

  try {
    const current = await ThemeIcon.getCurrentIcon();
    if (current?.theme === theme) {
      return;
    }

    await ThemeIcon.setThemeIcon({ theme });
  } catch (error) {
    console.warn('Failed to update app icon for theme:', error);
  }
};
